import React, { useEffect, useState } from "react";
import { getProducts, getImageUrl } from "../services/api";
import { useStore } from "../context/StoreContext";
import ProductCard from "../components/ProductCard";
import "./Shop.css";

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bannerUrl, setBannerUrl] = useState("");
  const { storeClosed, storeClosedMessage } = useStore();

  useEffect(() => {
    setBannerUrl(getImageUrl("shop-banner"));
  }, []);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const response = await getProducts();
        setProducts(response.data);
      } catch (error) {
        if (process.env.NODE_ENV === 'development') console.error("Erreur lors du chargement des produits:", error);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, []);

  return (
    <div className="shop">
      <section className="shop-hero" style={{ backgroundImage: bannerUrl ? `url(${bannerUrl})` : 'none' }}>
        <h1>Boutique</h1>
        <p>Découvres tes faiblesses à porter fièrement</p>
      </section>

      <div className="container">
        {storeClosed && (
          <div className="shop-store-closed-banner">
            <span className="shop-closed-icon">🔒</span>
            <span>
              {storeClosedMessage && storeClosedMessage.trim()
                ? storeClosedMessage
                : "La boutique est temporairement fermée. Les achats sont désactivés."}
            </span>
          </div>
        )}

        {loading ? (
          <div className="loading">Chargement...</div>
        ) : (
          <div className="products-grid">
            {products.map((product) => (
              <ProductCard key={product._id} product={product} />
            ))}
          </div>
        )}

        {products.length === 0 && !loading && (
          <p className="no-products">Aucun produit trouvé.</p>
        )}
      </div>
    </div>
  );
};

export default Shop;
